import {
  SHARE_LINK_DESCRIPTION,
  SHARE_LINK_IMAGE,
  SHARE_LINK_TITLE,
} from '../config/shareLink';

function setMetaAttr(selector, attr, name, content) {
  if (!content) return;
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

export function getShareTitle() {
  return SHARE_LINK_TITLE;
}

export function getShareDescription() {
  return SHARE_LINK_DESCRIPTION;
}

export function getShareImage() {
  return SHARE_LINK_IMAGE;
}

/** Sync document title and social meta tags. */
export function applySiteMeta() {
  const title = getShareTitle();
  const description = getShareDescription();
  const image = getShareImage();
  const url = typeof window !== 'undefined' ? window.location.href.split('?')[0] : '';

  document.title = title;
  setMetaAttr('meta[name="description"]', 'name', 'description', description);
  setMetaAttr('meta[property="og:title"]', 'property', 'og:title', title);
  setMetaAttr('meta[property="og:description"]', 'property', 'og:description', description);
  setMetaAttr('meta[property="og:image"]', 'property', 'og:image', image);
  if (url) setMetaAttr('meta[property="og:url"]', 'property', 'og:url', url);
  setMetaAttr('meta[name="twitter:title"]', 'name', 'twitter:title', title);
  setMetaAttr('meta[name="twitter:description"]', 'name', 'twitter:description', description);
  setMetaAttr('meta[name="twitter:image"]', 'name', 'twitter:image', image);
}
